import { useState } from 'react'

import {
  Box,
  Icon,
  Input,
  inputIconWidth,
  TransparentButton,
} from '@redriverpress/system'

function ShowPasswordToggle({ checked, onClick, ...props }) {
  return (
    <TransparentButton
      p={0}
      {...props}
      type='button'
      onClick={onClick}
      role='switch'
      aria-checked={checked}
      aria-label='Toggle password visibility'
    >
      <Icon icon={checked ? 'eye' : 'eye-slash'} />
    </TransparentButton>
  )
}

/** Input password with a toggle to reveal password */
export default function InputPassword(props) {
  const [showPassword, setShowPassword] = useState(false)

  const { type, error, iconRight } = props

  const inputType = showPassword ? 'text' : type

  return (
    <Box position='relative'>
      <Input
        {...props}
        pr={iconRight ? `calc(${inputIconWidth} * 2)` : inputIconWidth}
        type={inputType ?? 'password'}
      />

      <ShowPasswordToggle
        position='absolute'
        top={0}
        bottom={error ? '1.65rem' : 0}
        right={iconRight ? `calc(${inputIconWidth} - 0.5rem)` : 0}
        width={iconRight ? 'auto' : inputIconWidth}
        px={iconRight ? 1 : 0}
        checked={showPassword}
        onClick={() => setShowPassword(v => !v)}
      />
    </Box>
  )
}
